module.exports = __webpack_public_path__ + "static/media/YM71_1.d7ba3ee5.jpg";